export { default as extend } from './extend';
import app from 'flarum/forum/app';
import addKeyMetadataControl from './addKeyMetadataControl';
import addKeyMetadataComposer from './addKeyMetadataComposer';
import addKeyMetadataDetails from './addKeyMetadataDetails';

// The declarative `extend` array above (see ./extend.js) is this
// extension's original convention - author/language is added the same way
// champis-events adds its own metadata-on-a-tagged-discussion feature
// instead, since DiscussionControls/DiscussionComposer/DiscussionHero don't
// have as direct a declarative equivalent as a plain Model attribute or
// route does.
app.initializers.add('champis-keys', () => {
  addKeyMetadataControl();
  addKeyMetadataComposer();
  addKeyMetadataDetails();
});